import axios from 'axios'
import JSZip from 'jszip'
import FileSaver from 'file-saver'

/**
 * 根据url获取文件流
 * @param {String} url 待下载的文件url
 * @returns {AxiosPromise} 返回一个promise对象，resolve的参数是一个包含文件流的Blob对象
 */
export function downloadFileBuffer(url) {
  return axios({
    method: 'get',
    url: url,
    responseType: 'arraybuffer'
  })
}

/**
 * 根据指定的url列表下载文件，并打包成zip文件
 * @param {Array} files 文件列表，每个文件包含两个属性：fileName和fileUrl
 * @param {String} zipName zip文件名
 * @param {Function} beforeDownload 下载前的回调函数
 * @param {Function} afterDownload 下载后的回调函数
 * @param {Function} beforeArchive 压缩前的回调函数
 * @param {Function} afterArchive 压缩后的回调函数
 */
export async function archiveFilesToZip(files, zipName, {
  beforeDownload = () => {},
  afterDownload = () => {},
  beforeArchive = () => {},
  afterArchive = () => {}
} = {}) {
  // 下载前的回调
  beforeDownload && beforeDownload()
  const zip = new JSZip()
  const fileNameCache = {}
  // 循环多个文件并进行下载
  for (const file of files) {
    try {
      // 根据url获取文件流
      //这里加个判断，如果file.fileUrl不存在，则跳过
      if (!file.fileUrl){
        continue
      }
      const { data } = await downloadFileBuffer(file.fileUrl)
      // 检查文件名是否重复，如果重复则在文件名后面添加数字
      const fileName = checkAndGetFileNameRepeat(fileNameCache, file.fileName)
      // 将文件流添加到zip中
      zip.file(fileName, data, { binary: true })
    } catch (e) {
      console.error(e)
      throw new Error(`下载文件失败: ${file.fileName}`)
    }
  }
  // 下载后的回掉
  afterDownload && afterDownload()
  try {
    // 压缩前的回调
    beforeArchive && beforeArchive()
    // 生成zip文件
    const content = await zip.generateAsync({ type: 'blob' })
    // 保存zip文件
    FileSaver.saveAs(content, zipName)
    // 压缩后的回调
    afterArchive && afterArchive()
  } catch (e) {
    console.error(e)
    throw new Error('压缩文件失败')
  }
}

/**
 * 检查文件名是否重复，如果重复则在文件名后面添加数字
 * @param {Object} fileNameCache 文件名缓存对象
 * @param {String} fileName 文件名
 * @returns {String} 返回处理后的文件名
 */
function checkAndGetFileNameRepeat(fileNameCache, fileName) {
  if (fileNameCache[fileName]) {
    fileNameCache[fileName]++
    // 如果文件名重复，则在文件名后面添加数字。如果文件名有后缀，则在后缀前面添加数字，如：文件名_1.png; 如果没有后缀，则直接在文件名后面添加数字，如：文件名_1
    const index = fileName.lastIndexOf('.')
    if (index > 0) {
      fileName = `${fileName.substring(0, index)}_${fileNameCache[fileName]}${fileName.substring(index)}`
    } else {
      fileName = `${fileName}_${fileNameCache[fileName]}`
    }
  } else {
    fileNameCache[fileName] = 1
  }
  return fileName
}
